var _a;
/**
 * 渠道统一处理
 * 涉及 url 渠道，cookie 渠道
 * 以及 wrapperId
 */
import { queryString } from '../utils/url-helper';
import * as tjStorage from '../tj-storage';
import { getPlatform } from '../tj-utils/platform';
import { getElongOpenId } from './elong';
import * as elong_1 from './elong';
export { elong_1 as elong };
export var channelTypes = {
    TUJIA: 'tujia',
    CTRIP: 'ctrip',
    QUNAR: 'qunar',
    MAYI: 'mayi',
    ELONG: 'elong',
    JDBNB: 'jdbnb',
    KWAI: 'kwai'
};
var initChannelInfo = {
    channelId: '',
    channelText: '',
    channelWrapperId: '',
    get isTujia() {
        return (initChannelInfo.channelId === channelTypes.TUJIA ||
            initChannelInfo.channelId === '');
    },
    get isCtrip() {
        return initChannelInfo.channelId === channelTypes.CTRIP;
    },
    get isQunar() {
        return initChannelInfo.channelId === channelTypes.QUNAR;
    },
    get isMayi() {
        return initChannelInfo.channelId === channelTypes.MAYI;
    },
    get isElong() {
        return initChannelInfo.channelId === channelTypes.ELONG;
    },
    get isJd() {
        return initChannelInfo.channelId === channelTypes.JDBNB;
    },
    get isKwai() {
        return initChannelInfo.channelId === channelTypes.KWAI;
    },
    _isInit: false
};
var CHANNEL_INFOS = (_a = {},
    _a[channelTypes.TUJIA] = {
        channelId: channelTypes.TUJIA,
        channelText: '途家',
        channelWrapperId: '',
        channelCode: ''
    },
    _a[channelTypes.CTRIP] = {
        channelId: channelTypes.CTRIP,
        channelText: '携程',
        channelWrapperId: 'wapctripbnb',
        channelCode: ''
    },
    _a[channelTypes.QUNAR] = {
        channelId: channelTypes.QUNAR,
        channelText: '去哪儿',
        channelWrapperId: 'waptujia016',
        channelCode: ''
    },
    _a[channelTypes.MAYI] = {
        channelId: channelTypes.MAYI,
        channelText: '蚂蚁',
        channelWrapperId: '',
        channelCode: ''
    },
    _a[channelTypes.ELONG] = {
        channelId: channelTypes.ELONG,
        channelText: '同程旅行',
        channelWrapperId: 'wapelongbnb',
        channelCode: 'elong'
    },
    _a[channelTypes.JDBNB] = {
        channelId: channelTypes.JDBNB,
        channelText: '京东',
        channelWrapperId: 'wapjdcombnb',
        channelCode: 'jdbnb'
    },
    _a[channelTypes.KWAI] = {
        channelId: channelTypes.KWAI,
        channelText: '快手',
        channelWrapperId: 'wapkwaibnb',
        channelCode: 'kwai'
    },
    _a);
/**
 * 初始化途家系统渠道信息，获取和判定渠道信息，自动注入渠道信息到cookie
 * 调用一次即可
 */
export function initTujiaChannel() {
    // 获取url渠道信息 tjptid 改为 tjchannelid 原tjptid废弃
    var channelId = getChannelIdByQuery();
    var oldChannelId = tjStorage.getChannelId();
    /**
     * url无渠道参数 强制设置
     * 艺龙支付返回 未携带相关信息需要强制设置
     * 其他情况无渠道信息时 根据平台设置渠道信息
     * **/
    if (!channelId) {
        // 艺龙支付返回 未携带相关信息需要强制设置
        if (document.referrer && document.referrer.indexOf('cashier.ly.com') > -1) {
            channelId = channelTypes.ELONG;
        }
        else {
            /**
             * url 无渠道信息时 根据平台设置渠道信息
             * 这里要优先取平台来判断渠道，根据平台判断不出来的再使用历史 或者再默认途家渠道
             */
            channelId = getChannelByPlatform();
        }
    }
    /**
     * 渠道 cookie 写入处理
     * 接收到渠道 和 cookie 不一致，需要清除渠道信息
     * 无渠道 则使用历史或者再默认途家渠道
     */
    if (channelId) {
        if (oldChannelId && channelId !== oldChannelId) {
            clearCookieChannelInfo();
        }
    }
    else {
        channelId = oldChannelId || channelTypes.TUJIA;
    }
    // 设置渠道基本信息 code
    var currentChannel = CHANNEL_INFOS[channelId];
    if (!currentChannel) {
        currentChannel = CHANNEL_INFOS[channelTypes.TUJIA];
    }
    var code = queryString('code') || queryString('tujia_code') || '';
    var storageCode = tjStorage.getTujiaCode();
    // 强制清除 code_site
    tjStorage.setTujiaCodeSite('');
    // 小程序tbnb的增量标识
    var incflag = getIncflagByQuery();
    if (incflag) {
        tjStorage.setIncflag(incflag);
    }
    // 小程序tbnb的新首页标识
    var newindex = getNewindexByQuery();
    if (newindex) {
        tjStorage.setNewindex(newindex);
    }
    // 设置 code
    if (code && code !== storageCode) {
        // 优先获取 URL中的数据,没有的话 获取默认的
        tjStorage.setTujiaCode(code);
    }
    /**
     * 外部投放
     * qhclickid:360
     * click_id:小红书 会对值加上 tujia_xhs_ 前缀用于后续业务区分来源
     * */
    var outcode = queryString('outcode') || queryString('click_id') || '';
    if (queryString('click_id')) {
        outcode = 'tujia_xhs_' + queryString('click_id');
    }
    // 从cookie获取outcode
    var storageOutcode = tjStorage.getOutcode();
    // 设置 outcode
    if (outcode && outcode !== storageOutcode) {
        // 优先获取 URL中的数据,没有的话 获取默认的
        tjStorage.setOutcode(outcode);
    }
    // 有auth 则设置
    var auth = queryString('c_auth');
    if (auth) {
        tjStorage.setThirdAuth(auth);
    }
    // 有openId 则设置
    var openId = queryString('tjopenid') || queryString('openId') || queryString('openid');
    if (openId) {
        tjStorage.setOpenId(openId);
    }
    if (queryString('tjchanneltoken')) {
        tjStorage.setChannelToken(queryString('tjchanneltoken'));
    }
    // 每个渠道特殊处理
    switch (currentChannel.channelId) {
        case channelTypes.ELONG:
            var elongOpenId = getElongOpenId();
            if (elongOpenId) {
                tjStorage.setOpenId(elongOpenId);
            }
            break;
        case channelTypes.TUJIA:
        default:
            break;
    }
    // 设置 channelId
    tjStorage.setChannelId(currentChannel.channelId);
    // 设置 wrapperId
    var info = CHANNEL_INFOS[currentChannel.channelId];
    if (info === null || info === void 0 ? void 0 : info.channelWrapperId) {
        tjStorage.setChannelWrapperId(info === null || info === void 0 ? void 0 : info.channelWrapperId);
    }
    // CQ APP 特殊处理，屏蔽 wrapperId
    // if (platform.isCtripAppEnv || platform.isQunarAppEnv) {
    //   if (info) {
    //     info.channelWrapperId = ''
    //   }
    //   tjStorage.setChannelWrapperId('')
    // }
    // 更新 全局 body style
    if (currentChannel.channelId !== channelTypes.TUJIA) {
        document.body.classList.add("tj-channel-".concat(currentChannel.channelId));
    }
}
export function getChannelIdByQuery() {
    return queryString('tjchannelid') || queryString('tjptid');
}
export function getIncflagByQuery() {
    return queryString('incflag') || '';
}
export function getNewindexByQuery() {
    return queryString('newindex') || '';
}
/**
 * 清空渠道相关信息
 */
export function clearCookieChannelInfo() {
    tjStorage.setUserId('');
    tjStorage.setUserToken('');
    tjStorage.setChannelId('');
    tjStorage.setChannelWrapperId('');
    tjStorage.setChannelToken('');
    tjStorage.setTujiaCode('');
    tjStorage.setOutcode('');
    tjStorage.setOpenId('');
    tjStorage.setThirdAuth('');
}
/**
 * 获取渠道信息
 * @returns { channelId, channelText, channelWrapperId, isTujia, isCtrip, isQunar, isMayi, isElong, isJd, isKwai }
 */
export function getChannelInfo() {
    // 初始化过 直接返回
    if (initChannelInfo._isInit) {
        return initChannelInfo;
    }
    var channelId = getChannelIdByQuery() || tjStorage.getChannelId() || channelTypes.TUJIA;
    var info = CHANNEL_INFOS[channelId];
    if (!info) {
        info = CHANNEL_INFOS[channelTypes.TUJIA];
        info.channelId = channelId;
    }
    initChannelInfo.channelId = info.channelId;
    initChannelInfo.channelText = info.channelText;
    initChannelInfo.channelWrapperId = info.channelWrapperId;
    initChannelInfo._isInit = true;
    return initChannelInfo;
}
/**
 * 获取渠道 Token ，目前仅有 QE 有相关 Token
 * 返回值经过 JSON.parse 处理
 */
export function getChannelToken() {
    var tokenStr = tjStorage.getChannelToken();
    var data = {};
    if (tokenStr) {
        try {
            data = JSON.parse(decodeURIComponent(tokenStr));
        }
        catch (error) { }
    }
    return data;
}
/**
 * 根据平台获取渠道值
 */
function getChannelByPlatform() {
    // 设置 途家 携程 去哪儿 蚂蚁 艺龙 京东 等渠道值
    var platform = getPlatform();
    if (platform.isCtripAppEnv) {
        return channelTypes.CTRIP;
    }
    else if (platform.isQunarAppEnv) {
        return channelTypes.QUNAR;
    }
    else if (platform.isMayiAppEnv) {
        return channelTypes.MAYI;
    }
    else if (platform.isTEAppEnv) {
        return channelTypes.ELONG;
    }
    else if (platform.isJdAppEnv) {
        return channelTypes.JDBNB;
    }
    else if (platform.isKuaiShouMpEnv) {
        return channelTypes.KWAI;
    }
    else {
        return '';
    }
}
export default {
    initTujiaChannel: initTujiaChannel
};
